import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
import * as event from '@/store/modules/event.js'
import * as packageAPI from '@/store/modules/packageAPI.js'
import * as cart from '@/store/modules/cart.js'
import * as user from '@/store/modules/user.js'
import * as performance from "@/store/modules/performance.js"
import i18n from "@/translations/i18n"
import api from "@/util/api"

Vue.use(Vuex)

const MAX_API_ATTEMPTS = 3;

export default new Vuex.Store({
  state: {
    loading: false,
    loadingCount: 0,
    error: '',
    debugging: false,
    stage: "choose-date-time",
    progressBarPath: {
      paidEventNoSeatAllocation: false,
      paidEventNoSeatAllocationSeatMapRequired: false,
      standardSeatAllocation: false,
      bestAvailableOrHotShow: false
    },
    goBackValue: 0,
    headerMenu: [],
    footerPrimaryMenuItem: [],
    footerSecondaryMenuItem: [],
    socialMediaIcons: [],
    announcements: [],
    site: {},
    fallbackError: '',
    previousStage: ''
  },
  mutations: {
    SET_LOADING(state, value) {
      state.loading = value
    },
    SET_ERROR(state, value) {
      state.error = value
    },
    SET_STAGE(state, value) {
      state.stage = value
    },
    SET_DEBUG(state, value) {
      state.debugging = value;
    },
    SET_PROGRESS_BAR_PATH_KEY(state, value) {
      // pass a path & value to update
      state.progressBarPath[value.key] = value.value;
    },
    ITERATE_GO_BACK(state) {
      // This is a hack for go back to work outside of router-view
      state.goBackValue++;
    },
    SET_HEADER_MENU(state, value) {
      state.headerMenu = value
    },

    SET_TOP_MENU(state, value) {
      state.topMenu = value
    },

    SET_HEADER_BUTTON(state, value) {
      state.headerButton = value
    },

    SET_POPULAR_SEARCH_KEYWORDS(state, value) {
      state.popularSearchKeywords = value
    },
    SET_FOOTER_PRIMARY_MENU_ITEM(state, value) {
      state.footerPrimaryMenuItem = value
    },
    SET_SECONDARY_MENU_ITEM(state, value) {
      state.footerSecondaryMenuItem = value
    },
    SET_SOCIAL_MEDIA_ICONS(state, value) {
      state.socialMediaIcons = value
    },
    SET_ANNOUNCEMENTS(state, value) {
      state.announcements = value
    },
    SET_SITE(state, value) {
      state.site = value
    },
    SET_FALLBACK_ERROR(state, error) {
      state.fallbackError = error
    },
    SET_PREVIOUS_STAGE(state, stage) {
      state.previousStage = stage
    },

    SET_BLACK_SITE_LOGO(state, value) {
      state.blackSiteLogo = value
    },
    SET_WHITE_SITE_LOGO(state, value) {
      state.whiteSiteLogo = value
    },
    SET_TEXT_LOGO(state, value) {
      state.textLogo = value
    },
    SET_LOGO_LINK(state, value) {
      state.logoLink = value
    },
    SET_DESKTOP_LOGO_HEIGHT(state, value) {
      state.desktopLogoHeight = value
    },
    SET_DESKTOP_LOGO_WIDTH(state, value) {
      state.desktopLogoWidth = value
    },
    SET_MOBILE_LOGO_HEIGHT(state, value) {
      state.mobileLogoHeight = value
    },
    SET_MOBILE_LOGO_WIDTH(state, value) {
      state.mobileLogoWidth = value
    },
  },
  actions: {
    clearHeaderAndFooter({ commit }) {
      commit('SET_HEADER_MENU', Object.assign({}));
      commit('SET_TOP_MENU', []);
      commit('SET_HEADER_BUTTON', []);
      commit('SET_POPULAR_SEARCH_KEYWORDS', []);
      commit('SET_FOOTER_PRIMARY_MENU_ITEM', []);
      commit('SET_SECONDARY_MENU_ITEM', []);
      commit('SET_SOCIAL_MEDIA_ICONS', []);
      commit('SET_ANNOUNCEMENTS', []);
      commit('SET_SITE', []);

      commit('SET_BLACK_SITE_LOGO', []);
      commit('SET_WHITE_SITE_LOGO', []);
      commit('SET_TEXT_LOGO', []);
      commit('SET_LOGO_LINK', []);
      commit('SET_DESKTOP_LOGO_HEIGHT', []);
      commit('SET_DESKTOP_LOGO_WIDTH', []);
      commit('SET_MOBILE_LOGO_HEIGHT', []);
      commit('SET_MOBILE_LOGO_WIDTH', []);
    },
    async getMainSite({ commit, dispatch }) {
      dispatch('clearHeaderAndFooter')

      let attempts = 0;

      while (attempts < MAX_API_ATTEMPTS) {
        attempts++;

        try {
          let response = await api.getMainSite(i18n.locale);
          let response2 = await api.getHeaderFooter(i18n.locale);
          let anno_data = await api.getAnnouncements(i18n.locale);

          if (response.status == 200) {
            attempts = MAX_API_ATTEMPTS;
            let site = response.data;
            // commit('SET_FOOTER_PRIMARY_MENU_ITEM', site.footerMenuItems)
            commit('SET_SITE', Object.assign(site));
          } else {
            throw response;
          }

          if (response2.status == 200) {
            console.log("response2 1:");
            console.log(response2.data);
            commit('SET_HEADER_MENU', response2.data.menuItem);
            commit('SET_TOP_MENU', response2.data.topMenu);
            commit('SET_HEADER_BUTTON', response2.data.headerButton);
            commit('SET_POPULAR_SEARCH_KEYWORDS', response2.data.popularSearchKeywords);
            commit('SET_SECONDARY_MENU_ITEM', response2.data);
            commit('SET_SOCIAL_MEDIA_ICONS', response2.data.socialMediaIcons);

            commit('SET_BLACK_SITE_LOGO', response2.data.blackSiteLogo);
            commit('SET_WHITE_SITE_LOGO', response2.data.whiteSiteLogo);
            commit('SET_TEXT_LOGO', response2.data.textLogo);
            commit('SET_LOGO_LINK', response2.data.logoLink);
            commit('SET_DESKTOP_LOGO_HEIGHT', response2.data.desktopLogoHeight);
            commit('SET_DESKTOP_LOGO_WIDTH', response2.data.desktopLogoWidth);
            commit('SET_MOBILE_LOGO_HEIGHT', response2.data.mobileLogoHeight);
            commit('SET_MOBILE_LOGO_WIDTH', response2.data.mobileLogoWidth);
          }else{
            throw response2;
          }

          if (anno_data.status == 200) {
            commit('SET_ANNOUNCEMENTS', anno_data.data);
          }else{
            throw anno_data;
          }
          
        } catch (e) {
          failedToGetMainSite(e)
        }
      }

      function failedToGetMainSite(e) {
        if (attempts == MAX_API_ATTEMPTS) {
          console.error('getMainSite222', e)
        }
      }
    },
    triggerGoBack({ commit, dispatch }) {
      commit('ITERATE_GO_BACK');
      dispatch('scrollToTopOfPurchasePath')
    },
    updateDebug({ commit }, value) {
      commit('SET_DEBUG', value)
    },
    resetProgressBar({ commit }) {
      commit('SET_PROGRESS_BAR_PATH_KEY', { key: 'paidEventNoSeatAllocation', value: false });
      commit('SET_PROGRESS_BAR_PATH_KEY', { key: 'paidEventNoSeatAllocationSeatMapRequired', value: false });
      commit('SET_PROGRESS_BAR_PATH_KEY', { key: 'standardSeatAllocation', value: false });
      commit('SET_PROGRESS_BAR_PATH_KEY', { key: 'bestAvailableOrHotShow', value: false });
      commit('SET_PROGRESS_BAR_PATH_KEY', { key: 'registration', value: false });
    },
    updateProgressBarPath({ commit }, update) {
      commit('SET_PROGRESS_BAR_PATH_KEY', update)
    },
    updateStage({ commit, state }, value) {
      // !!!!VERY IMPORTANT !!!! we're destroyingCartInstance based on this - Remove / update with extreme caution
      // This sets the last navigation time (for clearing out store)
      document.cookie = "lastNavigation=" + new Date() + ';path=/'

      commit('SET_PREVIOUS_STAGE', state.stage)
      commit('SET_STAGE', value)
    },
    updateLoading({ commit }, value) {
      commit('SET_LOADING', value)
    },
    updateError({ commit }, value) {
      commit('SET_ERROR', value)
    },
    scrollToTopOfPurchasePath() {
      // Chucking this in a function in case we want to scroll to specific places in the future
      window.scrollTo(0, 0);
    },
    updateSisticError({ commit }, errorCode) {
      let errorPath = "sistic." + errorCode;

      commit('SET_ERROR', errorPath)
    },
    clearError({ commit }) {
      commit('SET_ERROR', "")
      commit('SET_FALLBACK_ERROR', "")
    },
    updateFallbackError({ commit }, error) {
      commit('SET_FALLBACK_ERROR', error)
    }
  },
  modules: {
    event,
    user,
    cart,
    performance,
    packageAPI
  },
  getters: {
    errorPresent: state => {
      return state.error.length > 0;
    },
    secondaryLinks: state => {
      // don't return contact us link
      return state.footerSecondaryMenuItem.filter((item) => {
        // 联络我们 = Simplified: contact us
        // 聯絡我們 = Traditional: contact us
        // contact = English
        return !item.title.toLowerCase().includes("contact") && !item.title.toLowerCase().includes("联络我们") && !item.title.toLowerCase().includes("聯絡我們");;
      });
    },
    contactLinks: state => {
      return state.footerSecondaryMenuItem.filter((item) => {
        return item.title.toLowerCase().includes("contact") || item.title.toLowerCase().includes("联络我们") || item.title.toLowerCase().includes("聯絡我們");
      });
    },
    getSignupUrl: state => {
      return `${process.env.VUE_APP_WK_CRM_URL}/oauth/register?redirect=${process.env.VUE_APP_WK_FRONT_END_URL}&language=${i18n.locale}`;
    },
    getWhatsOnUrl: state => {
      let lang = i18n.locale;
      let wkSiteUrl = process.env.VUE_APP_WK_FRONT_END_URL;
      let whatsOnPath = "/en/whats-on";

      if (lang === "sc") {
        whatsOnPath = "/sc/whats-on";
      }
      if (lang === "tc") {
        whatsOnPath = "/tc/whats-on";
      } else {
        whatsOnPath;
      }

      return wkSiteUrl + whatsOnPath;
    },
    getBaseUrl: state => {
      let baseUrl = process.env.VUE_APP_WK_FRONT_END_URL;
      return baseUrl;
    },
    inProduction: state => {
      return process.env.VUE_APP_DEBUG_ON.toLowerCase() == 'false'
    }
  },
  plugins: [createPersistedState()],
});
